export class AwsVaultConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "bucketName",
            "baseName": "bucketName",
            "type": "string",
            "format": ""
        },
        {
            "name": "bucketPrefix",
            "baseName": "bucketPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsVaultConfig.attributeTypeMap;
    }
    constructor() {
    }
}
